import { useState, useEffect } from "react";

export const getBase64FromUrl = async (url:any) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

export function useImage(url:any) {
  const [image, setImage] = useState<string|undefined>(undefined);

  useEffect(() => {
    getBase64FromUrl(url).then((dataURL) => setImage(dataURL as string));
  }, [url]);

  return image;
}
